import { render, staticRenderFns } from "./LocalCalendarEditModal.vue?vue&type=template&id=19e583ab"
import script from "./LocalCalendarEditModal.vue?vue&type=script&lang=ts"
export * from "./LocalCalendarEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19e583ab')) {
      api.createRecord('19e583ab', component.options)
    } else {
      api.reload('19e583ab', component.options)
    }
    module.hot.accept("./LocalCalendarEditModal.vue?vue&type=template&id=19e583ab", function () {
      api.rerender('19e583ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calendar/LocalCalendarEditModal.vue"
export default component.exports